module.exports = __webpack_public_path__ + "img/USERAL.deab7927.svg";